import React from "react";
import { Wind, BarChart, Home } from "react-feather";

const MUDLogoLight =
    require("@src/assets/images/the-club/factions/mud_white.svg").default;
const MUDLogoDark =
    require("@src/assets/images/the-club/factions/mud_dark.svg").default;
const USTURLogoLight =
    require("@src/assets/images/the-club/factions/ustur_white.svg").default;
const USTURLogoDark =
    require("@src/assets/images/the-club/factions/ustur_dark.svg").default;
const ONILogoLight =
    require("@src/assets/images/the-club/factions/oni_white.svg").default;
const ONILogoDark =
    require("@src/assets/images/the-club/factions/oni_dark.svg").default;
const PieChartLight =
    require("@src/assets/images/the-club/layout/pie_chart_white.svg").default;
const PieChartDark =
    require("@src/assets/images/the-club/layout/pie_chart_dark.svg").default;
const CupDark =
    require("@src/assets/images/the-club/factions/cup_dark.svg").default;
const CupLight =
    require("@src/assets/images/the-club/factions/cup_light.svg").default;
const FactionsDark =
    require("@src/assets/images/the-club/factions/factions_dark.svg").default;
const FactionsLight =
    require("@src/assets/images/the-club/factions/factions_light.svg").default;

const CompareShipsDark =
    require("../../../src/assets/images/the-club/ships/CompareShipsDark.svg").default;
const CompareShipsLight =
    require("../../../src/assets/images/the-club/ships/CompareShipsWhite.svg").default;

const StakingStatsDark =
    require("../../../src/assets/images/the-club/ships/StakingStatsDark.svg").default;
const StakingStatsLight =
    require("../../../src/assets/images/the-club/ships/StakingStatsWhite.svg").default;

const AssetsLight =
    require("../../../src/assets/images/icons/asset-icons/assets_white.svg").default;
const AssetsDark =
    require("../../../src/assets/images/icons/asset-icons/assets_dark.svg").default;
const RebirthLight =
    require("../../../src/assets/images/icons/asset-icons/rebirth_white.svg").default;
const RebirthDark =
    require("../../../src/assets/images/icons/asset-icons/rebirth_dark.svg").default;
const AccessLight =
    require("../../../src/assets/images/icons/asset-icons/access_white.svg").default;
const AccessDark =
    require("../../../src/assets/images/icons/asset-icons/access_dark.svg").default;
const CosmeticLight =
    require("../../../src/assets/images/icons/asset-icons/cosmetic_white.svg").default;
const CosmeticDark =
    require("../../../src/assets/images/icons/asset-icons/cosmetic_dark.svg").default;
const CrewLight =
    require("../../../src/assets/images/icons/asset-icons/crew_white.svg").default;
const CrewDark =
    require("../../../src/assets/images/icons/asset-icons/crew_dark.svg").default;
const EquipmentLight =
    require("../../../src/assets/images/icons/asset-icons/equipment_white.svg").default;
const EquipmentDark =
    require("../../../src/assets/images/icons/asset-icons/equipment_dark.svg").default;
const ShipLight =
    require("../../../src/assets/images/icons/asset-icons/ship_white.svg").default;
const ShipDark =
    require("../../../src/assets/images/icons/asset-icons/ship_dark.svg").default;
const StructureLight =
    require("../../../src/assets/images/icons/asset-icons/structure_white.svg").default;
const StructureDark =
    require("../../../src/assets/images/icons/asset-icons/structure_dark.svg").default;
const J33ves = require("../../../src/assets/images/icons/j33ve.svg").default;
const J33vesLight =
    require("../../../src/assets/images/icons/j33veLight.svg").default;

export default [
    {
        id: "explore",
        title: "explore",
        header: "EXPLORE",
        navLink: "/",
    },
    {
        id: "home",
        title: "Home",
        icon: <Home />,
        iconDark: <Home />,
        badge: "light-warning",
        navLink: "/home",
    },
    {
        id: "leaderboard",
        title: "Leaderboard",
        icon: (
            <img
                src={CupLight}
                alt="pie-chart"
                height="24px"
                className="pr-2"
            />
        ),
        iconDark: (
            <img src={CupDark} alt="pie-chart" height="24px" className="pr-2" />
        ),
        badge: "light-warning",
        navLink: "/leaderboard",
    },
    {
        id: "stakingstats",
        title: "Staking Stats",
        icon: (
            <img
                src={StakingStatsLight}
                alt="pie-chart"
                height="20px"
                className="pr-1"
            />
        ),
        iconDark: (
            <img
                src={StakingStatsDark}
                alt="pie-chart"
                height="20px"
                className="pr-1"
            />
        ),
        navLink: "/ships/staking",
    },
    {
        id: "compareships",
        title: "Compare",
        icon: (
            <img
                src={CompareShipsLight}
                alt="pie-chart"
                height="20px"
                className="pr-1"
            />
        ),
        iconDark: (
            <img
                src={CompareShipsDark}
                alt="pie-chart"
                height="20px"
                className="pr-1"
            />
        ),
        badge: "light-warning",
        navLink: "/ships/compare",
    },
    {
        id: "assets",
        title: "Assets",
        icon: (
            <img
                src={AssetsLight}
                alt="pie-chart"
                height="20px"
                className="pr-1"
            />
        ),
        iconDark: (
            <img
                src={AssetsDark}
                alt="pie-chart"
                height="20px"
                className="pr-1"
            />
        ),
        badge: "light-warning",
        navLink: "/assets/rebirth",
        children: [
            {
                id: "rebirth",
                title: "Rebirth",
                icon: (
                    <img
                        src={RebirthLight}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                iconDark: (
                    <img
                        src={RebirthDark}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                badge: "light-warning",
                navLink: "/assets/rebirth",
            },
            {
                id: "access",
                title: "Access",
                icon: (
                    <img
                        src={AccessLight}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                iconDark: (
                    <img
                        src={AccessDark}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                badge: "light-warning",
                navLink: "/assets/access",
            },
            {
                id: "cosmetic",
                title: "Cosmetic",
                icon: (
                    <img
                        src={CosmeticLight}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                iconDark: (
                    <img
                        src={CosmeticDark}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                badge: "light-warning",
                navLink: "/assets/cosmetic",
            },
            {
                id: "crew",
                title: "Crew",
                icon: (
                    <img
                        src={CrewLight}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                iconDark: (
                    <img
                        src={CrewDark}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                badge: "light-warning",
                navLink: "/assets/crew",
            },
            {
                id: "equipment",
                title: "Equipment",
                icon: (
                    <img
                        src={EquipmentLight}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                iconDark: (
                    <img
                        src={EquipmentDark}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                badge: "light-warning",
                navLink: "/assets/equipment",
            },
            {
                id: "ship",
                title: "Ship",
                icon: (
                    <img
                        src={ShipLight}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                iconDark: (
                    <img
                        src={ShipDark}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                badge: "light-warning",
                navLink: "/assets/ship",
            },
            {
                id: "structure",
                title: "Structure",
                icon: (
                    <img
                        src={StructureLight}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                iconDark: (
                    <img
                        src={StructureDark}
                        alt="pie-chart"
                        height="20px"
                        className="pr-1"
                    />
                ),
                badge: "light-warning",
                navLink: "/assets/structure",
            },
        ],
    },
    {
        id: "jeeves",
        title: "J33ves",
        icon: (
            <img src={J33vesLight} alt="pie-chart" height="20px" className="pr-1" />
        ),
        iconDark: (
            <img
                src={J33ves}
                alt="pie-chart"
                height="20px"
                className="pr-1"
            />
        ),
        badge: "light-warning",
        navLink: "/j33ves",
    },

    // {
    //   id: "factions",
    //   title: "Factions",
    //   icon: (
    //     <img src={FactionsLight} alt="pie-chart" height="24px" className="pr-2" />
    //   ),
    //   iconDark: (
    //     <img src={FactionsDark} alt="pie-chart" height="24px" className="pr-2" />
    //   ),
    //   badge: "light-warning",
    //   // badgeText: '4',
    //   children: [
    //     {
    //       id: "assetChart",
    //       title: "Asset Charts",
    //       icon: (
    //         <img
    //           src={PieChartLight}
    //           alt="pie-chart"
    //           height="20px"
    //           style={{ paddingRight: "16px" }}
    //         />
    //       ),
    //       iconDark: (
    //         <img
    //           src={PieChartDark}
    //           alt="pie-chart"
    //           height="20px"
    //           style={{ paddingRight: "16px" }}
    //         />
    //       ),
    //       navLink: "/factions/asset-charts",
    //     },
    //     {
    //       id: "mudAssets",
    //       title: "MUD Assets",
    //       icon: (
    //         <img src={MUDLogoLight} alt="mud" height="20px" className="pr-1" />
    //       ),
    //       iconDark: (
    //         <img src={MUDLogoDark} alt="mud" height="20px" className="pr-1" />
    //       ),
    //       navLink: "/factions/mud-assets",
    //     },
    //     {
    //       id: "usturAssets",
    //       title: "USTUR Assets",
    //       icon: (
    //         <img src={USTURLogoLight} alt="mud" height="20px" className="pr-1" />
    //       ),
    //       iconDark: (
    //         <img src={USTURLogoDark} alt="mud" height="20px" className="pr-1" />
    //       ),
    //       navLink: "/factions/ustur-assets",
    //     },
    //     {
    //       id: "oni",
    //       title: "ONI Assets",
    //       icon: (
    //         <img src={ONILogoLight} alt="mud" height="20px" className="pr-1" />
    //       ),
    //       iconDark: (
    //         <img src={ONILogoDark} alt="mud" height="20px" className="pr-1" />
    //       ),
    //       navLink: "/factions/oni-assets",
    //     },
    //   ],
    // },
];
